import { ECHA, FETCH_ECHAS, REJECTED } from 'actionTypes';
import { echaTransformForImport } from 'utils/echa/columns';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import { apiRequest } from 'utils/request';

// CUSTOM ACTIONS
const handleError = (TYPE, error, dispatch) => {
  console.log('error: ', error);
  if (error.response) {
    if (error.response.status === 401) {
      dispatch({ type: 'LOGOUT' });
    } else {
      dispatch({ type: TYPE + REJECTED, payload: error.response.statusText });
    }
  } else {
    dispatch({ type: TYPE + REJECTED, payload: 'Unknown error' });
  }
};

const importEchas = echas => dispatch => {
  const echasForImport = echas.map(echa => echaTransformForImport(echa));

  // One call. Emptying the register is the first thing the import does on the
  // server, inside the same transaction, so there is nothing to chain here -
  // and nothing to get wrong: the DELETE and the POST used to be two requests
  // whose promises were never joined, so a failed import left the table empty
  // and said nothing.
  return apiRequest('/echa/batch_import/', 'POST', echasForImport)
    .then(() => {
      // Insertion on DB takes a while so the FETCH is delayed
      setTimeout(() => dispatch({ type: FETCH_ECHAS }), 10000);
    })
    .catch(error => handleError(ECHA, error, dispatch));
};

// ACTIONS
const rawActions = actionsFactory(ECHA);
const actions = { ...rawActions, importEchas };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

const parseJsonString = value => {
  return JSON.parse(value);
};

const options = {
  orderBy: {
    what: ['name'],
    how: ['asc']
  },
  sanitizers: {
    cas: parseJsonString,
    ec: parseJsonString,
    restriction_descriptions: parseJsonString,
    restriction_entry_numbers: parseJsonString
  }
};

export default reducerFactory(ECHA, initialState, options);

// SAGAS
const sagas = sagasFactory(ECHA, '/echa/');
export { sagas };
